import { Image } from '@sunwebgroup/uds-ui/image'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { buildImgSrc, ImageOrigin } from '@/helpers/image-url'
import styles from './FavoriteHero.module.css'

const HERO_IMAGE_WIDTH = 1440
const HERO_IMAGE_HEIGHT = 320

interface FavoriteHeroProps {
  imageUrl: string | null
  title: string
}

export function FavoriteHero({
  imageUrl,
  title,
}: FavoriteHeroProps) {
  return (
    <section className={styles.hero}>
      {imageUrl && (
        <Image
          alt=""
          className={styles.image}
          src={buildImgSrc(imageUrl, HERO_IMAGE_WIDTH, HERO_IMAGE_HEIGHT, ImageOrigin.CMSSitecore)}
        />
      )}
      <Typography as="h1" className={styles.title} variant="display-e-regular">
        {title}
      </Typography>
    </section>
  )
}
